import pageAttributes from "./page_attributes";

export { pageAttributes };

export const DEFAULT_DATA_PROVIDERS = {
  pageAttributes,
};
